var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-sm btn--primary px-4 ml-3",attrs:{"type":"button"},on:{"click":_vm.openAddServiceCategory}},[_vm._v(" Add Service Category ")]),_c('AddServiceCategoryModal',{attrs:{"id":'addServiceCategory',"closeModal":_vm.closeModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }